import React from 'react'

import { SortDrawer } from 'components/UI/SortDrawer'
import type { SortOption, SortEntry, SortDrawerProps } from 'components/UI/SortDrawer'

/**
 * Activity sort — the field list, and nothing else.
 *
 * The sheet itself is `components/UI/SortDrawer`. This file used to carry its own
 * ~203-line copy of it; the copies differed only in this list.
 *
 * Types declared here for the first time; `date` was offering "A - Z" / "Z - A".
 */
export type ActivitySortField = 'date' | 'type'
export type ActivitySortDirection = 'ASC' | 'DESC'
export type AdditionalActivitySort = SortEntry<ActivitySortField>

const OPTIONS: SortOption<ActivitySortField>[] = [
  { key: 'date', label: 'Date', type: 'dateTime' },
  { key: 'type', label: 'Type', type: 'string' },
]

export type ActivitySortDrawerProps = Omit<SortDrawerProps<ActivitySortField>, 'options'>

export const ActivitySortDrawer: React.FC<ActivitySortDrawerProps> = props => (
  <SortDrawer<ActivitySortField> {...props} options={OPTIONS} />
)

export default ActivitySortDrawer
